import React from 'react';
import { ArrowRight } from 'lucide-react';

const Footer = () => {
  const handleClaimPageClick = () => {
    // Route to landing page
    window.open('https://usekinos.com', '_blank');
  };

  return (
    <footer className="bg-gradient-to-br from-purple-50 to-pink-50 py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* CTA Section */}
        <div className="text-center mb-8">
          <h3 className="text-2xl font-semibold text-gray-800 mb-3">
            Ready to build your page?
          </h3>
          
          <button
            onClick={handleClaimPageClick}
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white font-medium py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-105"
          >
            <span>Claim Your Page</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-purple-200 to-transparent mb-6"></div>
        
        {/* Powered by */}
        <p className="text-center text-gray-500 text-sm">
          Powered by{' '}
          <a
            href="https://usekinos.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-600 font-medium hover:text-purple-700 hover:underline transition-colors duration-300"
          >
            kinOS
          </a>
        </p>
        
      </div>
    </footer>
  );
};

export default Footer;